import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import {
  Table,
  Modal,
  Card,
  Icon,
  Button,
  Input,
  Divider,
  Dimmer,
  Loader,
} from "semantic-ui-react"
import { useDispatch, useSelector } from "react-redux"
import { apiGet } from "../utils/apiConnector"
import { emissionCodesApi } from "../config/apiUrls"

const OrderModalComponent = (props) => {
  const { t } = useTranslation()
  const formatDate = (dt) => {
    const months = [
      "",
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ]
    const parsedString = dt.split("-")
    const year = parseInt(parsedString[0])
    const month = parseInt(parsedString[1])
    const day = parseInt(parsedString[2].slice(0, 2))
    const time = parsedString[2].slice(3, 8)
    return (
      <>
        <div>
          <p>
            {day} {t(months[month])} {year} {t("in")} {time}
          </p>
        </div>
      </>
    )
  }
  const { data, isLoading, setModal } = props
  const [count, setCount] = useState(data[1].length ? data[1][0].available : 0)
  const [mdl, setMdl] = useState(false)
  const [cnt, setCnt] = useState("")
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const renderMdl = () => {
    return (
      <>
        <Modal
          open={mdl}
          onClose={() => {
            setCnt("")
            setMdl(false)
          }}
          style={{ marginTop: "-40vh", height: "max-content" }}
          size={"tiny"}
        >
          <Card fluid>
            <Card.Content>
              <div>
                <Input
                  value={cnt}
                  onClick={(e, d) => {
                    if (d.value > data[1][0].qty) {
                      setCnt("")
                    } else setCnt(d.value)
                  }}
                  type="number"
                  placeholder={t("Quantity")}
                />
              </div>
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  negative
                  content={t("Cancel")}
                  onClick={() => {
                    setMdl(false)
                    setCnt("")
                  }}
                />
                <Button
                  positive
                  content={t("Get marking codes")}
                  onClick={() => {
                    apiGet(emissionCodesApi, {
                      emissionId: data[1][0].id,
                      count: cnt,
                    })
                      .onOk((res) => {
                        console.log(res.data.response)
                        setCount(count)
                      })
                      .onFail(() => {})
                      .afterAll(() => {
                        setModal(false)
                      })
                      .startSingle()
                  }}
                  disabled={!cnt}
                />
              </div>
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  return (
    <>
      {renderMdl()}
      <Dimmer active={isLoading} inverted>
        <Loader />
      </Dimmer>
      <div>
        <div style={{ fontWeight: 600, fontSize: 22 }}>
          {t("Order")} {data[1].length ? data[1][0].id : ""}
        </div>
        <div style={{ display: "flex", width: "100%", marginTop: 30 }}>
          <div style={{ width: "50%" }}>
            <div>
              {t("Date of creation")}{" "}
              <b>{data[1].length ? formatDate(data[1][0].dt) : ""}</b>
            </div>
            <Divider />
            <div>
              {t("Status")} <b>{data[1].length ? data[1][0].status : ""}</b>
            </div>
            <Divider />
            <div>
              {t("Execution time (milliseconds)")}{" "}
              <b>{data[1].length ? data[1][0].completionTime : ""}</b>
            </div>
            <div style={{ marginTop: 20, display: "none" }}>
              Номер договора с Оператором ИС МП <b>1</b>
            </div>
            {
              // <Divider />
            }
            <div>
              {t("Product order ID")} <br />
              <b>{data[1].length ? data[1][0].orderId : ""}</b>
            </div>
            <Divider />
            <div>
              {t("Contact name")}{" "}
              <b>{data[1].length ? data[1][0].contactName : ""}</b>
            </div>
            <Divider />
            <div style={{ display: "none" }}>
              Способ выпуска товаров в оборот <b>Производство в РФ</b>
            </div>
            {
              //<Divider />
            }
            <div>
              {t("Preparation method")}{" "}
              <b>
                {data[1].length
                  ? data[1][0].serialType === "SELF_MADE"
                    ? t("SELF_MADE")
                    : data[1][0].serialType === "OPERATOR"
                    ? t("OPERATOR")
                    : ""
                  : ""}
              </b>
            </div>
          </div>
          <div style={{ width: "50%", paddingLeft: 30 }}>
            <div>
              GTIN <b>{data[1].length ? data[1][0].gtin : ""}</b>
            </div>
            <div style={{ marginTop: 15 }}>
              {t("Codes total")} <b>{data[1].length ? data[1][0].qty : 0}</b>
            </div>
            <div style={{ marginTop: 15 }}>
              {t("Codes received")} <b>{count}</b>
            </div>
            <div style={{ marginTop: 15 }}>
              {t("Status")}{" "}
              <span style={{ display: "inline-block", color: "green" }}>
                {data[1].length ? data[1][0].status : ""}
              </span>
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 30,
            display: data[1].length
              ? data[1][0].orderId
                ? "flex"
                : "none"
              : "none",
          }}
        >
          <div>
            <Button
              positive
              content={t("Get marking codes")}
              onClick={() => {
                setMdl(true)
              }}
            />
          </div>
          <div style={{ marginLeft: 20 }}>
            <Button content={t("Close suborder")} />
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderModalComponent
